export default __webpack_public_path__ + "static/media/me copy - Nimisha Das.66f73f52.jpg";